import { render, staticRenderFns } from "./ChiPhiBanHang.vue?vue&type=template&id=e883d0a4&"
import script from "./ChiPhiBanHang.vue?vue&type=script&lang=js&"
export * from "./ChiPhiBanHang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports